<template>
  <b-container style="margin-top: 15px">
    <b-row>
      <b-col>
        <b-button
              class="float-right"
              variant="warning"
              style="margin-left: 15px"
          >
          <b-icon
              icon="envelope"
              aria-hidden="true"
          />
          </b-button>
        <b-button
            class="float-right"
            variant="warning"
        >
          <b-icon
              icon="printer"
              aria-hidden="true"
          />
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "Sessions_Registration",
  components: {},
  props: {
    profile: {
      type: Object,
      default: () => {
        return {}
      }
    },
    session: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  mounted() {
  },
  methods: {},
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
